import React, { createContext, useState, useEffect } from 'react';

// Crear el contexto
export const LoginContext = createContext();

// Proveedor del contexto
export const LoginProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const setEmpresaId = (emp_id) => {
    const updatedUser = { ...user, emp_id };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

  const isAuthenticated = !!user;

  return (
    <LoginContext.Provider value={{ user, login, logout, isAuthenticated, setEmpresaId }}>
      {children}
    </LoginContext.Provider>
  );
};
